import { analyticsEcommerceVendorClick } from "../../helpers/analytics";
import { isExternalLink } from "../../helpers/isExternalLink";
import { notNullish } from "../../helpers/notNullish";
import { ButtonPcs } from "../ButtonPcs/ButtonPcs";
import { SelectButton, type items } from "../SelectButton/SelectButton";
import { CosmosButtonProps } from "@cosmos/web-react";
import { ComponentProps } from "react";

/** Same as SelectButton items (url, label, icon) but nullable for CMS data */
export type VendorLink = {
  url: items["url"] | null;
  label: items["label"] | null;
  icon: items["icon"] | null;
};

export const BuyNowVendorLinks = ({
  label,
  className,
  buttonSize = "medium",
  buttonAppearance = "dark",
  links,
  analyticsElementPosition = "VendorLink",
  buttonCustomColor,
  listboxPosition,
}: {
  label: string;
  className: string;
  buttonSize: CosmosButtonProps["size"];
  buttonAppearance?: CosmosButtonProps["appearance"];
  links: VendorLink[];
  analyticsElementPosition: string;
  buttonCustomColor?: ComponentProps<typeof ButtonPcs>["customColor"];
  listboxPosition?: "above" | "below";
}) => {
  return (
    <SelectButton
      buttonClassName={className}
      buttonSize={buttonSize}
      buttonAppearance={buttonAppearance}
      buttonCustomColor={buttonCustomColor ?? undefined}
      listboxPosition={listboxPosition}
      label={label ?? ""}
      items={
        links.filter(notNullish).map((item) => ({
          label: item?.label ?? "",
          url: item?.url ?? "",
          icon: item?.icon ?? undefined,
          onClick: () =>
            analyticsEcommerceVendorClick({
              value: item?.label,
              clickUrl: item?.url,
              elementPosition: analyticsElementPosition,
              method: isExternalLink(item?.url ?? "")
                ? "Outbound: TRUE"
                : "Outbound: FALSE",
              contentType: "Button Click, Buy now",
            }),
        })) ?? []
      }
    />
  );
};
